import React from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import Fallback from "./pages/Fallback/Fallback";
import Archive from "./pages/Archive/Archive";
import Project from "./pages/Project/Project";
import HomepageWrapper from "./pages/HomepageWrapper/HomepageWrapper";
import ContactWrapper from "./pages/ContactWrapper/ContactWrapper";


const AnimatedRoutes = ({controlAuxCursor, setCursorText, isFirstLoad, isOutdatedSafari, setIsHomeScreen, setTriggerArchiveToHomepageTransition, setTriggerHomepageToProjectTransition, setHomeToArchiveTransitionTrigger}) =>{
    const location = useLocation();

    return (
            <AnimatePresence initial="false" mode="wait">
                <Routes location={location} key={location.pathname}> 
                    <Route exact path="/" element={<HomepageWrapper isFirstLoad={isFirstLoad} setCursorText={setCursorText} controlAuxCursor={controlAuxCursor} setIsHomeScreen={setIsHomeScreen} setTriggerHomepageToProjectTransition={setTriggerHomepageToProjectTransition} setTriggerArchiveToHomepageTransition={setTriggerArchiveToHomepageTransition} setHomeToArchiveTransitionTrigger={setHomeToArchiveTransitionTrigger}/>}/>
                    <Route exact path="/Contact" element={<ContactWrapper setCursorText={setCursorText} />}/>
                    <Route key={'archive_'+location} exact path="/Archive" element={<Archive setCursorText={setCursorText} location={location} setTriggerArchiveToHomepageTransition={setTriggerArchiveToHomepageTransition} setHomeToArchiveTransitionTrigger={setHomeToArchiveTransitionTrigger}/>}/>
                    <Route key={'project_'+location} exact path="/Projects/:projectID" element={<Project  setCursorText={setCursorText} />}/>
                    <Route path='*' element={<Fallback />}/>
                </Routes>
            </AnimatePresence>
    );
}

export default AnimatedRoutes;